import { jsx as _jsx } from "react/jsx-runtime";
import Confirm from "./Confirm";
import Create from "./Create";
import Receipt from "./Receipt";
import TransferAndPaymentsContainer from "./TransfersAndPaymentsContainer";
const TransferPayments = (props) => (_jsx(TransferAndPaymentsContainer, { ...props }));
TransferPayments.Confirm = Confirm;
TransferPayments.Create = Create;
TransferPayments.Receipt = Receipt;
export default TransferPayments;
